import { call, put, select, takeLatest } from "redux-saga/effects";

import * as BotpressAPI from "../../data/api/omniBotpressAPI.js";
import { createOmniPaginationObject } from "../../utils/helpers";
import { deepCopyObject, helperGetIsoDate } from "../../utils/helpers.js";
import * as UserSessionStorage from "../../utils/userSessionStorage";
import * as Actions from "../redux/botpressSession";

const getDefaultPagination = () => {
  let newPage = createOmniPaginationObject(null, 20);
  newPage.pageIndex = 0;
  newPage.sort = { createdAt: "desc" };
  return newPage;
};

export function* setBotpressBotODM({ payload }) {
  try {
    //get the current and clear it out

    if (payload != null) {
      const botId = payload.omniData.botId;
      yield call(UserSessionStorage.storeLastBotpressBotID, botId);
    }

    yield put(Actions.setBotpressBotODMSuccess(payload));

    //The subsequent methods may not have the state/date set yet, so we grab it ourselves
    const startDate = yield select(Actions.analyticsStartDateSelector);
    let theParameters = {
      botODM: payload,
      analyticsStartDate: startDate,
    };
    yield put(Actions.loadAnalyticsRequest(theParameters));
    yield put(Actions.loadBotRequest(theParameters));
    yield put(Actions.loadBotpressSummaryRequest(theParameters));
    yield put(Actions.loadConfigurationsRequest(theParameters));

    // //Tables load this via pagination when needed
    // const chatPage = yield select(Actions.chatPaginationSelector);
    // chatPage["botODM"] = payload;
    // yield put(Actions.searchChatsRequest(chatPage));

    //load feedback
    const feedbackPage = yield select(Actions.feedbackPaginationSelector);
    feedbackPage["botODM"] = payload;
    yield put(Actions.searchFeedbackRequest(feedbackPage));

    //load assessment
    const assessmentPage = yield select(Actions.assessmentPaginationSelector);
    assessmentPage["botODM"] = payload;
    yield put(Actions.searchAssessmentRequest(assessmentPage));

    //load products
    const productPage = yield select(Actions.productPaginationSelector);
    productPage["botODM"] = payload;
    yield put(Actions.searchProductsRequest(productPage));
  } catch (error) {
    yield put(Actions.loadAnalyticsRequest(null));
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* setAnalyticsBotODM({ payload }) {
  try {
    //get the current and clear it out
    yield put(Actions.setAnalyticsBotODMSuccess(payload));
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* loadAnalytics({ payload }) {
  try {
    const yesterdayEverythingSeemedSoFarAway = new Date(helperGetIsoDate(1, true, true)); //today but start of the day
    //All this shit is to handler initialization, you can pass in empty payloads after setting the bot
    const startDate =
      payload.analyticsStartDate != null
        ? new Date(payload.analyticsStartDate)
        : yesterdayEverythingSeemedSoFarAway;
    const currentAnalytics = yield select(Actions.analyticsSelector);
    const currentStartDate = yield select(Actions.analyticsStartDateSelector);

    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (botpressBotODM == null) {
      yield put(
        Actions.loadAnalyticsSuccess({
          analytics: null,
          analyticsStartDate: startDate,
        }),
      );
      return;
    }

    //first load so just get it, it will be the 30 days....
    if (!currentAnalytics) {
      //today
      const endDate = new Date(helperGetIsoDate(0, false, true)); //today

      let theParameters = {
        botODM: botpressBotODM,
        analyticsStartDate: startDate,
        analyticsEndDate: endDate,
      };
      let theReturn = yield call(BotpressAPI.getBotAnalytics, theParameters);

      if (theReturn) {
        yield put(
          Actions.loadAnalyticsSuccess({
            analytics: theReturn.records,
            analyticsStartDate: startDate,
          }),
        );
      }
    } else if (startDate < currentStartDate) {
      const currentAnalytics = yield select(Actions.analyticsSelector);
      let newAnalytics = currentAnalytics.slice();

      let newEndDate = new Date(currentStartDate.getTime());
      newEndDate.setDate(newEndDate.getDate() - 1);

      let newStartDate = new Date(newEndDate.getTime());
      newStartDate.setDate(newEndDate.getDate() - 29);

      do {
        let theParameters = {
          botODM: botpressBotODM,
          analyticsStartDate: newStartDate,
          analyticsEndDate: newEndDate,
        };

        let theReturn = yield call(BotpressAPI.getBotAnalytics, theParameters);
        newAnalytics.unshift(...theReturn.records);
        // newAnalytics.push(...theReturn.records);

        newEndDate.setDate(newStartDate.getDate() - 1);
        newStartDate.setDate(newEndDate.getDate() - 29);
      } while (startDate <= newStartDate);

      yield put(
        Actions.loadAnalyticsSuccess({
          analytics: newAnalytics,
          analyticsStartDate: startDate,
        }),
      );
    } else {
      //data is already there, they asked for less than we have
      yield put(
        Actions.loadAnalyticsSuccess({
          analytics: currentAnalytics,
          analyticsStartDate: currentStartDate,
        }),
      );
    }
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* loadBot({ payload }) {
  try {
    //All this shit is to handler initialization, you can pass in empty payloads after setting the bot
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (botpressBotODM != null) {
      let theParameters = {
        botODM: botpressBotODM,
      };
      let theReturn = yield call(BotpressAPI.getBot, theParameters);
      yield put(Actions.loadBotSuccess(theReturn.bot));
    } else {
      yield put(Actions.loadBotSuccess(null));
    }
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* loadBotpressSummary({ payload }) {
  try {
    //All this shit is to handler initialization, you can pass in empty payloads after setting the bot
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (botpressBotODM != null) {
      let theParameters = {
        botODM: botpressBotODM,
      };
      let theReturn = yield call(BotpressAPI.getBotpressSummary, theParameters);
      yield put(Actions.loadBotpressSummarySuccess(theReturn));
    } else {
      yield put(Actions.loadBotpressSummarySuccess(null));
    }
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* searchChats({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (botpressBotODM != null) {
      const currentPagination = yield select(Actions.chatPaginationSelector);
      //payload is a "currentPagination" from helpers.js
      let currentCacheInvalid = false;
      if (
        payload.pageSize !== currentPagination.pageSize ||
        JSON.stringify(payload.query) !== JSON.stringify(currentPagination.query) ||
        JSON.stringify(payload.sort) !== JSON.stringify(currentPagination.sort) ||
        payload.botODM != null ||
        payload.invalidateCache ||
        payload.hasOwnProperty("chatStartDate")
      ) {
        //something fundamental has changed
        currentCacheInvalid = true;
      }
      let chatPages = yield select(Actions.chatPagesSelector);
      if (!currentCacheInvalid && chatPages.hasOwnProperty(payload.pageIndex)) {
        //FML
        console.log("BotpressSession: Already Have Row:  " + payload.pageIndex);

        payload["botODM"] = botpressBotODM;
        const propertyCount = Object.keys(chatPages).length;
        const lastPageLength = chatPages[propertyCount - 1].odms.length;
        payload.totalItems = (propertyCount - 1) * payload.pageSize + lastPageLength;
        if (lastPageLength === payload.pageSize) {
          payload.totalItems += 1; //to indicate more items
        }
        yield put(
          Actions.searchChatsSuccess({
            chatPages: chatPages,
            chats: chatPages[payload.pageIndex].odms,
            chatPagination: payload,
          }),
        );
      } else {
        let newChatPages = {};
        let tmpPayload = deepCopyObject(payload);
        tmpPayload["botODM"] = botpressBotODM;

        let startDate = yield select(Actions.chatStartDateSelector);
        if (tmpPayload.hasOwnProperty("chatStartDate")) {
          startDate = tmpPayload.chatStartDate;
          delete tmpPayload.chatStartDate;
        }

        let endDate = yield select(Actions.chatEndDatesSelector);
        if (tmpPayload.hasOwnProperty("chatEndDate")) {
          endDate = tmpPayload.chatEndDate;
          delete tmpPayload.chatEndDate;
        }

        let query = tmpPayload.query;
        query["createdAt"] = {
          $gte: new Date(startDate), // Greater than or equal to start date
          $lte: new Date(endDate), // Less than or equal to end date
        };

        tmpPayload.query = query;
        let hasMore = true;
        let index = 0;
        for (; hasMore; index++) {
          tmpPayload.pageIndex = index;
          let theReturn = yield call(BotpressAPI.searchConversations, tmpPayload);
          //upate the currentPagination
          newChatPages[index] = { odms: theReturn.rows };
          hasMore = theReturn.hasMore;
        }

        --index;
        payload.totalItems = index * payload.pageSize + newChatPages[index].odms.length;

        yield put(
          Actions.searchChatsSuccess({
            chatPages: newChatPages,
            chats: newChatPages[payload.pageIndex]?.odms || [],
            chatPagination: payload,
          }),
        );

        yield put(Actions.analyzeChatsRequest(newChatPages));
      }
    } else {
      yield put(
        Actions.searchChatsSuccess({
          chatPages: {},
          chats: [],
          chatPagination: payload,
        }),
      );
    }
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* searchFlaggedChats({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (botpressBotODM != null) {
      const currentPagination = yield select(Actions.flaggedChatPaginationSelector);
      //payload is a "currentPagination" from helpers.js
      let currentCacheInvalid = false;
      if (
        payload.pageSize !== currentPagination.pageSize ||
        JSON.stringify(payload.query) !== JSON.stringify(currentPagination.query) ||
        JSON.stringify(payload.sort) !== JSON.stringify(currentPagination.sort) ||
        payload.botODM != null ||
        payload.invalidateCache
      ) {
        //something fundamental has changed
        currentCacheInvalid = true;
      }
      let flaggedChatPages = yield select(Actions.flaggedChatPagesSelector);
      if (!currentCacheInvalid && flaggedChatPages.hasOwnProperty(payload.pageIndex)) {
        //FML
        console.log("BotpressSession: Already Have Row:  " + payload.pageIndex);

        payload["botODM"] = botpressBotODM;
        const propertyCount = Object.keys(flaggedChatPages).length;
        const lastPageLength = flaggedChatPages[propertyCount - 1].odms.length;
        payload.totalItems = (propertyCount - 1) * payload.pageSize + lastPageLength;
        if (lastPageLength === payload.pageSize) {
          payload.totalItems += 1; //to indicate more items
        }
        yield put(
          Actions.searchFlaggedChatsSuccess({
            flaggedChatPages: flaggedChatPages,
            flaggedChats: flaggedChatPages[payload.pageIndex].odms,
            flaggedChatPagination: payload,
          }),
        );
      } else {
        let newflaggedChatPages = {};
        let tmpPayload = deepCopyObject(payload);
        tmpPayload["botODM"] = botpressBotODM;

        let query = tmpPayload.query;
        query["tracking"] = true;

        tmpPayload.query = query;
        let hasMore = true;
        let index = 0;
        for (; hasMore; index++) {
          tmpPayload.pageIndex = index;
          let theReturn = yield call(BotpressAPI.searchConversations, tmpPayload);
          //upate the currentPagination
          newflaggedChatPages[index] = { odms: theReturn.rows };
          hasMore = theReturn.hasMore;
        }

        --index;
        payload.totalItems = index * payload.pageSize + newflaggedChatPages[index].odms.length;

        yield put(
          Actions.searchFlaggedChatsSuccess({
            flaggedChatPages: newflaggedChatPages,
            flaggedChats: newflaggedChatPages[payload.pageIndex]?.odms || [],
            flaggedChatPagination: payload,
          }),
        );
      }
    } else {
      yield put(
        Actions.searchFlaggedChatsSuccess({
          chatPages: {},
          chats: [],
          chatPagination: payload,
        }),
      );
    }
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* setSearchChatsDates({ payload }) {
  try {
    //get the current and clear it out

    const currentPagination = yield select(Actions.chatPaginationSelector);

    currentPagination["chatStartDate"] = payload.chatStartDate;
    currentPagination["chatEndDate"] = payload.chatEndDate;
    yield put(Actions.setSearchChatsDatesSuccess(payload));

    yield put(Actions.searchChatsRequest(currentPagination));
  } catch (error) {
    yield put(Actions.loadAnalyticsRequest(null));
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* analyzeChats({ payload }) {
  try {
    // const chatPages = payload != null ? payload : yield select(Actions.chatPagesSelector);
    const chatPages = payload;
    const pageCount = Object.keys(chatPages).length;

    //TODO standardize this..
    let theResults = {
      topicFrequency: [],
    };

    const frequencyMap = new Map();
    const sentimentMap = new Map();

    for (let pageIndex = 0; pageIndex < pageCount; ++pageIndex) {
      for (let rowIndex = 0; rowIndex < chatPages[pageIndex].odms.length; ++rowIndex) {
        let currentRow = chatPages[pageIndex].odms[rowIndex];
        if (currentRow.topics != null) {
          for (let topicIndex = 0; topicIndex < currentRow.topics.length; ++topicIndex) {
            let theTopic = currentRow.topics[topicIndex];
            frequencyMap.set(theTopic, (frequencyMap.get(theTopic) || 0) + 1);
          }
        }
        if (currentRow.sentiment != null) {
          sentimentMap.set(currentRow.sentiment, (sentimentMap.get(currentRow.sentiment) || 0) + 1);
        }
      }
    }

    const sortedMapDesc = new Map([...frequencyMap].sort((a, b) => b[1] - a[1]));
    theResults["topicFrequency"] = sortedMapDesc;

    const sortedSentimentMap = new Map([...sentimentMap].sort((a, b) => b[1] - a[1]));
    theResults["sentimentFrequency"] = sortedSentimentMap;

    yield put(Actions.analyzeChatsSuccess(theResults));
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* deleteChat({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (payload.conversationId != null) {
      //delete the chat
      payload["botODM"] = botpressBotODM;
      let theReturn = yield call(BotpressAPI.deleteConversation, payload);

      if (Object.hasOwn(theReturn, "code")) {
        yield put(Actions.botpressSessionRequestFailed(theReturn));
      } else {
        const chatPage = yield select(Actions.chatPaginationSelector);
        //setting the botODM triggers reload
        chatPage["botODM"] = botpressBotODM;
        chatPage["invalidateCache"] = true;
        yield put(Actions.searchChatsRequest(chatPage));
      }
    }
    //reload
    Actions.deleteChatSuccess({});
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* updateChat({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (payload.chatRecords != null) {
      payload["botODM"] = botpressBotODM;
      let theReturn = yield call(BotpressAPI.updateChat, payload);

      if (Object.hasOwn(theReturn, "code")) {
        yield put(Actions.botpressSessionRequestFailed(theReturn));
      } else {
        //filter the current Conversations and add that back in.
        const chatPage = yield select(Actions.chatPaginationSelector);
        //setting the botODM triggers reload
        chatPage["botODM"] = botpressBotODM;
        chatPage["invalidateCache"] = true;
        yield put(Actions.searchChatsRequest(chatPage));

        //now do the new feedback.
        const flaggedChatPage = yield select(Actions.flaggedChatPaginationSelector);
        //setting the botODM triggers reload
        flaggedChatPage["botODM"] = botpressBotODM;
        flaggedChatPage["invalidateCache"] = true;

        yield put(Actions.searchFlaggedChatsRequest(flaggedChatPage));
      }
      yield put(Actions.updateChatSuccess({}));
    }
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* searchFeedback({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    const currentPagination = yield select(Actions.feedbackPaginationSelector);
    if (botpressBotODM != null) {
      //payload is a "currentPagination" from helpers.js
      let currentCacheInvalid = false;
      if (
        payload.pageSize !== currentPagination.pageSize ||
        JSON.stringify(payload.query) !== JSON.stringify(currentPagination.query) ||
        JSON.stringify(payload.sort) !== JSON.stringify(currentPagination.sort) ||
        payload.botODM != null ||
        payload.invalidateCache
      ) {
        //something fundamental has changed
        currentCacheInvalid = true;
      }
      let feedbackPages = yield select(Actions.feedbackPagesSelector);
      if (!currentCacheInvalid && feedbackPages.hasOwnProperty(payload.pageIndex)) {
        //FML
        payload["botODM"] = botpressBotODM;
        const propertyCount = Object.keys(feedbackPages).length;
        const lastPageLength = feedbackPages[propertyCount - 1].odms.length;
        payload.totalItems = (propertyCount - 1) * payload.pageSize + lastPageLength;
        if (lastPageLength === payload.pageSize) {
          payload.totalItems += 1; //to indicate more items
        }
        yield put(
          Actions.searchFeedbackSuccess({
            feedbackPages: feedbackPages,
            feedback: feedbackPages[payload.pageIndex].odms,
            feedbackPagination: payload,
          }),
        );
      } else {
        let newFeedbackPages = {};
        let tmpPayload = deepCopyObject(payload);
        tmpPayload["botODM"] = botpressBotODM;

        let hasMore = true;
        let index = 0;
        for (; hasMore; index++) {
          tmpPayload.pageIndex = index;
          let theReturn = yield call(BotpressAPI.searchFeedback, tmpPayload);
          //upate the currentPagination
          newFeedbackPages[index] = { odms: theReturn.rows };
          hasMore = theReturn.hasMore;
        }

        --index;
        payload.totalItems = index * payload.pageSize + newFeedbackPages[index].odms.length;

        yield put(
          Actions.searchFeedbackSuccess({
            feedbackPages: newFeedbackPages,
            feedback: newFeedbackPages[payload.pageIndex]?.odms || [],
            feedbackPagination: payload,
          }),
        );
      }
    } else {
      yield put(
        Actions.searchFeedbackSuccess({
          feedbackPages: {},
          feedback: [],
          feedbackPagination: payload,
        }),
      );
    }
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* updateFeedback({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (payload.feedbackRecords != null) {
      let results = [];

      //delete the chat
      payload["botODM"] = botpressBotODM;
      let theReturn = null;
      if (payload.feedbackRecords.length === 1 && payload.feedbackRecords[0].id == null) {
        theReturn = yield call(BotpressAPI.addFeedback, payload);
        results = theReturn.rows;
      } else {
        theReturn = yield call(BotpressAPI.updateFeedback, payload);
        results = theReturn.inserted.concat(theReturn.updated);
      }

      if (Object.hasOwn(theReturn, "code")) {
        yield put(Actions.botpressSessionRequestFailed(theReturn));
      } else {
        const feedbackPage = yield select(Actions.feedbackPaginationSelector);
        //setting the botODM triggers reload
        feedbackPage["botODM"] = botpressBotODM;
        feedbackPage["invalidateCache"] = true;
        yield put(Actions.searchFeedbackRequest(feedbackPage));
      }

      yield put(Actions.updateFeedbackSuccess({}));

      //check for the conversation feedback
      const conversationId = yield select(Actions.conversationIdSelector);
      if (conversationId != null && results.length > 0) {
        //this only works for one at a time
        let currentList = yield select(Actions.conversationFeedbackSelector);
        let doIt = false;
        for (let i = 0; i < results.length; ++i) {
          if (results[i].conversationId === conversationId) {
            currentList =
              currentList == null ? [] : currentList.filter(obj => obj.id !== results[i].id);
            currentList.push(results[i]);
            doIt = true;
          }
        }

        if (doIt) {
          yield put(Actions.updateConversationFeedbackSuccess(currentList));
        }
      }
    }
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* deleteFeedback({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (payload.feedbackIDs != null) {
      //delete the chat
      payload["botODM"] = botpressBotODM;
      let theReturn = yield call(BotpressAPI.deleteFeedback, payload);
      if (Object.hasOwn(theReturn, "code")) {
        yield put(Actions.botpressSessionRequestFailed(theReturn));
      } else {
        const feedbackPage = yield select(Actions.feedbackPaginationSelector);
        //setting the botODM triggers reload
        feedbackPage["botODM"] = botpressBotODM;
        yield put(Actions.searchFeedbackRequest(feedbackPage));
      }
    }
    yield put(Actions.deleteFeedbackSuccess({}));
    const conversationId = yield select(Actions.conversationIdSelector);
    if (conversationId != null) {
      //this only works for one at a time
      let currentList = yield select(Actions.conversationFeedbackSelector);
      for (let i = 0; i < payload.feedbackIDs.length; ++i) {
        currentList =
          currentList == null ? [] : currentList.filter(obj => obj.id !== payload.feedbackIDs[i]);
      }
      yield put(Actions.updateConversationFeedbackSuccess(currentList));
    }
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

//#region Assessment

export function* searchAssessment({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    const currentPagination = yield select(Actions.assessmentPaginationSelector);
    if (botpressBotODM != null) {
      //payload is a "currentPagination" from helpers.js
      let currentCacheInvalid = false;
      if (
        payload.pageSize !== currentPagination.pageSize ||
        JSON.stringify(payload.query) !== JSON.stringify(currentPagination.query) ||
        JSON.stringify(payload.sort) !== JSON.stringify(currentPagination.sort) ||
        payload.botODM != null ||
        payload.invalidateCache
      ) {
        //something fundamental has changed
        currentCacheInvalid = true;
      }
      let assessmentPages = yield select(Actions.assessmentPagesSelector);
      if (!currentCacheInvalid && assessmentPages.hasOwnProperty(payload.pageIndex)) {
        //FML
        payload["botODM"] = botpressBotODM;
        const propertyCount = Object.keys(assessmentPages).length;
        const lastPageLength = assessmentPages[propertyCount - 1].odms.length;
        payload.totalItems = (propertyCount - 1) * payload.pageSize + lastPageLength;
        if (lastPageLength === payload.pageSize) {
          payload.totalItems += 1; //to indicate more items
        }
        yield put(
          Actions.searchAssessmentSuccess({
            assessmentPages: assessmentPages,
            assessment: assessmentPages[payload.pageIndex].odms,
            assessmentPagination: payload,
          }),
        );
      } else {
        payload["botODM"] = botpressBotODM;
        let theReturn = yield call(BotpressAPI.searchAssessment, payload);
        //upate the currentPagination
        payload.totalItems = payload.pageIndex * payload.pageSize + theReturn.rows.length;
        if (theReturn.hasMore) {
          //assumes payload is full fo rthe pageSize if true
          payload.totalItems += 1; //to indicate more items
        }

        if (currentCacheInvalid) {
          assessmentPages = {};
        }
        assessmentPages[payload.pageIndex] = { odms: theReturn.rows };

        yield put(
          Actions.searchAssessmentSuccess({
            assessmentPages: assessmentPages,
            assessment: theReturn.rows,
            assessmentPagination: payload,
          }),
        );
      }
    } else {
      yield put(
        Actions.searchAssessmentSuccess({
          assessmentPages: {},
          assessment: [],
          assessmentPagination: payload,
        }),
      );
    }
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* updateAssessment({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (payload.assessmentRecord != null) {
      //delete the chat
      payload["botODM"] = botpressBotODM;
      let theReturn = null;
      if (payload.assessmentRecord.id == null) {
        theReturn = yield call(BotpressAPI.addAssessment, payload);
      } else {
        theReturn = yield call(BotpressAPI.updateAssessment, payload);
      }

      if (Object.hasOwn(theReturn, "code")) {
        yield put(Actions.botpressSessionRequestFailed(theReturn));
      } else {
        const assessmentPage = yield select(Actions.assessmentPaginationSelector);
        //setting the botODM triggers reload
        assessmentPage["botODM"] = botpressBotODM;
        yield put(Actions.searchAssessmentRequest(assessmentPage));
      }
    }

    //reload
    Actions.updateAssessmentSuccess({});
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* deleteAssessments({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (payload.assessmentIDs != null) {
      //delete the chat
      payload["botODM"] = botpressBotODM;
      let theReturn = yield call(BotpressAPI.deleteAssessments, payload);
      if (Object.hasOwn(theReturn, "code")) {
        yield put(Actions.botpressSessionRequestFailed(theReturn));
      } else {
        const assessmentPage = yield select(Actions.assessmentPaginationSelector);
        //setting the botODM triggers reload
        assessmentPage["botODM"] = botpressBotODM;
        yield put(Actions.searchAssessmentRequest(assessmentPage));
      }
    }

    //reload
    Actions.deleteAssessmentsSuccess({});
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

//#endregion

//#region Products

export function* searchProducts({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    const currentPagination = yield select(Actions.productPaginationSelector);

    if (botpressBotODM != null) {
      //payload is a "currentPagination" from helpers.js
      let currentCacheInvalid = false;
      if (
        payload.pageSize !== currentPagination.pageSize ||
        JSON.stringify(payload.query) !== JSON.stringify(currentPagination.query) ||
        JSON.stringify(payload.sort) !== JSON.stringify(currentPagination.sort) ||
        payload.botODM != null ||
        payload.invalidateCache
      ) {
        //something fundamental has changed
        currentCacheInvalid = true;
      }

      let productPages = yield select(Actions.productPagesSelector);

      if (!currentCacheInvalid && productPages.hasOwnProperty(payload.pageIndex)) {
        //FML
        payload["botODM"] = botpressBotODM;

        const propertyCount = Object.keys(productPages).length;
        const lastPageLength = productPages[propertyCount - 1].odms.length;
        payload.totalItems = (propertyCount - 1) * payload.pageSize + lastPageLength;

        if (lastPageLength === payload.pageSize) {
          payload.totalItems += 1; //to indicate more items
        }

        const allProducts = Object.keys(productPages)
          .sort((a, b) => Number(a) - Number(b))
          .flatMap(key => productPages[key].odms);

        yield put(
          Actions.searchProductsSuccess({
            productPages: productPages,
            products: allProducts,
            productPagination: payload,
          }),
        );
      } else {
        let newProductPages = {};
        let tmpPayload = deepCopyObject(payload);
        tmpPayload["botODM"] = botpressBotODM;

        let hasMore = true;
        let index = 0;
        let allProducts = [];

        for (; hasMore; index++) {
          tmpPayload.pageIndex = index;

          let theReturn = yield call(BotpressAPI.searchProducts, tmpPayload);

          //upate the currentPagination
          if (Object.hasOwn(theReturn, "code")) {
            newProductPages = {};
            allProducts = [];
            hasMore = false;
          } else {
            newProductPages[index] = { odms: theReturn.rows };
            allProducts = allProducts.concat(theReturn.rows);
            hasMore = theReturn.hasMore;
          }
        }

        --index;
        payload.totalItems = allProducts.length;

        yield put(
          Actions.searchProductsSuccess({
            productPages: newProductPages,
            products: allProducts,
            productPagination: payload,
          }),
        );
      }
    } else {
      yield put(
        Actions.searchProductsSuccess({
          productPages: {},
          products: [],
          productPagination: payload,
        }),
      );
    }
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* updateProduct({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (payload.productRecord != null) {
      //delete the chat
      payload["botODM"] = botpressBotODM;
      let theReturn = null;

      if (payload.productRecord.id == null) {
        theReturn = yield call(BotpressAPI.addProduct, payload);
      } else {
        theReturn = yield call(BotpressAPI.updateProduct, payload);
      }

      if (Object.hasOwn(theReturn, "code")) {
        yield put(Actions.botpressSessionRequestFailed(theReturn));
      } else {
        const productPage = yield select(Actions.productPaginationSelector);
        //setting the botODM triggers reload
        productPage["botODM"] = botpressBotODM;
        productPage["invalidateCache"] = true;
        yield put(Actions.searchProductsRequest(productPage));
      }
    }

    //reload
    yield put(Actions.updateProductSuccess({}));
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* deleteProducts({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (payload.productIDs != null) {
      //delete the chat
      payload["botODM"] = botpressBotODM;
      let theReturn = yield call(BotpressAPI.deleteProducts, payload);

      if (Object.hasOwn(theReturn, "code")) {
        yield put(Actions.botpressSessionRequestFailed(theReturn));
      } else {
        const productPage = yield select(Actions.productPaginationSelector);
        //setting the botODM triggers reload
        productPage["botODM"] = botpressBotODM;
        productPage["invalidateCache"] = true;
        yield put(Actions.searchProductsRequest(productPage));
      }
    }

    //reload
    yield put(Actions.deleteProductsSuccess({}));
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

//#endregion

export function* loadConversation({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload && payload.botODM != null
        ? payload.botODM
        : yield select(Actions.botpressBotODMSelector);

    if (payload != null) {
      const credentialedPayload = { botODM: botpressBotODM, conversationId: payload };
      const theMessages = yield call(BotpressAPI.loadConversation, credentialedPayload);
      //load feedback

      const newPage = createOmniPaginationObject(null, 50);
      newPage.pageIndex = 0;
      newPage.sort = { createdAt: "desc" };
      newPage.query = { conversationId: payload };
      newPage["botODM"] = botpressBotODM;

      const feedbackRecords = yield call(BotpressAPI.searchFeedback, newPage);

      yield put(
        Actions.loadConversationSuccess({
          conversationId: payload,
          conversation: theMessages,
          conversationFeedback: feedbackRecords.rows,
        }),
      );
    } else {
      //reset it, null payload
      yield put(
        Actions.loadConversationSuccess({
          conversationId: null,
          conversation: null,
          conversationFeedback: null,
        }),
      );
    }
    // //reload
    // Actions.loadConversationSuccess(payload);
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* setBotAssessmentState({ payload }) {
  try {
    let theParameters = {
      conversationId: payload.conversationId,
      userKey: payload.userKey,
    };

    yield put(Actions.setBotAssessmentStateSuccess(theParameters));
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* loadConfigurations({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);
    if (botpressBotODM != null) {
      let tmpPayload = getDefaultPagination();
      tmpPayload["botODM"] = botpressBotODM;
      let hasMore = true;
      let index = 0;
      let newRows = [];
      for (; hasMore; index++) {
        tmpPayload.pageIndex = index;
        let theReturn = yield call(BotpressAPI.searchConfiguration, tmpPayload);
        newRows = newRows.concat(theReturn.rows);
        hasMore = theReturn.hasMore;
      }
      yield put(Actions.loadConfigurationsSuccess(newRows));
    }
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* setRerunConversationId({ payload }) {
  try {
    if (payload == null) {
      yield put(
        Actions.setRerunConversationIdSuccess({
          rerunConversationId: null,
          rerunConversationNumber: null,
          rerunFeedbackNumber: null,
        }),
      );
    }
    yield put(Actions.setRerunConversationIdSuccess(payload));
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

//  saga
export default function* userSessionSaga() {
  yield takeLatest(Actions.setBotpressBotODMRequest, setBotpressBotODM);
  yield takeLatest(Actions.setAnalyticsBotODMRequest, setAnalyticsBotODM);
  yield takeLatest(Actions.loadAnalyticsRequest, loadAnalytics);
  yield takeLatest(Actions.loadConfigurationsRequest, loadConfigurations);
  yield takeLatest(Actions.loadBotpressSummaryRequest, loadBotpressSummary);
  yield takeLatest(Actions.loadBotRequest, loadBot);
  yield takeLatest(Actions.searchChatsRequest, searchChats);
  yield takeLatest(Actions.setSearchChatsDatesRequest, setSearchChatsDates);
  yield takeLatest(Actions.analyzeChatsRequest, analyzeChats);
  yield takeLatest(Actions.deleteChatRequest, deleteChat);
  yield takeLatest(Actions.updateChatRequest, updateChat);
  yield takeLatest(Actions.searchFeedbackRequest, searchFeedback);
  yield takeLatest(Actions.updateFeedbackRequest, updateFeedback);
  yield takeLatest(Actions.deleteFeedbackRequest, deleteFeedback);
  yield takeLatest(Actions.searchFlaggedChatsRequest, searchFlaggedChats);
  yield takeLatest(Actions.searchAssessmentRequest, searchAssessment);
  yield takeLatest(Actions.updateAssessmentRequest, updateAssessment);
  yield takeLatest(Actions.deleteAssessmentsRequest, deleteAssessments);
  yield takeLatest(Actions.searchProductsRequest, searchProducts);
  yield takeLatest(Actions.updateProductRequest, updateProduct);
  yield takeLatest(Actions.deleteProductsRequest, deleteProducts);

  yield takeLatest(Actions.loadConversationRequest, loadConversation);
  yield takeLatest(Actions.setBotAssessmentStateRequest, setBotAssessmentState);
  yield takeLatest(Actions.setRerunConversationIdRequest, setRerunConversationId);
}
